import React, { useContext, useEffect } from 'react'
import SilageStepLayout from '../SilageStepLayout'
import { Table } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { useFormContext, useWatch } from 'react-hook-form'
import { StyledGroup } from './style'
import { ClimaOptionsContext } from '.'
import CO2Service from '~/api/services/co2'
import { useParams } from 'react-router-dom'
import { handleErrors } from '~/utils/helpers'

const tableColumnHeaders = [
  {
    name: 'Arbeitsgänge',
    key: 'label'
  },
  {
    name: 'Anzahl der Durchgänge',
    key: 'passages',
    type: 'input',
    unit: 'Durchgänge'
  },
  {
    name: 'Entfernung',
    key: 'distance',
    type: 'input',
    unit: 'km'
  }
]

const ThirdGrassStep: React.FC = () => {
  const { control, setValue, clearErrors, getValues } = useFormContext()
  const { workOperations, setIsLoadingResults, setWorkOperations } = useContext(ClimaOptionsContext)
  const { id } = useParams()
  const watchOperations = useWatch({ control, name: 'grassSilage.workOperations' }) || []

  useEffect(() => {
    const workOperationsValues = getValues('grassSilage.workOperations') || []
    if (workOperationsValues.length > 0 && workOperations.length === 0) {
      setWorkOperations(workOperationsValues)
      return
    }

    const idMain = getValues('grassSilage.harvestingMethods[0].id')
    if ((workOperations.length === 0 || idMain) || workOperationsValues.length === 0) {
      fetchWorkOperations(idMain)
    }
  }, [])

  async function fetchWorkOperations(idMain: string) {
    setIsLoadingResults(true)
    try {
      const response = await CO2Service.getGrassSilagePredefinedData(id, { main: idMain })
      const workOperations = response.data.workOperations.map(workOperation => ({ id: workOperation.id, distance: '', passages: '' }))
      setValue('grassSilage.workOperations', workOperations)
      setWorkOperations(response.data.workOperations)
    } catch (error) {
      handleErrors(error)
    } finally {
      setIsLoadingResults(false)
    }
  }

  function renderInputCellValue(name, unit: string) {
    return <FormFields.Input
      placeholder={`in ${unit}`}
      name={name}
      suffix={` ${unit}`}
      onChange={(event) => {
        setValue(name, event?.target?.value?.replace(unit, ''))
        clearErrors(name)
      }}
      rules={{
        required: true
      }}
      control={control}
      typeInput={'controled'}
      withoutAsterisk
      noErrorMessage
      allowDecimals
      decimalScale={1}
    />
  }


  function renderCell(workOperation, name, column) {
    switch (column.type) {
      case 'input':
        return renderInputCellValue(name, column?.unit)
      default:
        return workOperation[column.key]
    }
  }

  function renderTableBody() {
    return watchOperations?.map((workOperation, indexFertilizer) => {
      return <Table.Row key={workOperation.id}>
        {tableColumnHeaders.map(column => {
          const name = `grassSilage.workOperations[${indexFertilizer}].${column.key}`
          if (column.key === 'label') {
            const label = workOperations.find(workOp => workOp.id === workOperation.id)?.label || ''
            return <Table.Cell key={`${column.key}-${workOperation.id}`}>
              {label}
            </Table.Cell>
          }
          return <Table.Cell key={`${column.key}-${column.key}`}>
            {renderCell(workOperation, name, column)}
          </Table.Cell>
        })}
      </Table.Row>
    })
  }


  function renderTable() {
    return <Table celled striped compact>
      <Table.Header>
        <Table.Row>
          {tableColumnHeaders.map(header => {
            return <Table.HeaderCell key={header.key}>
              {header.name}
            </Table.HeaderCell>
          })}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {renderTableBody()}
      </Table.Body>
    </Table>
  }

  return (
    <SilageStepLayout
      infoText={`Die Erfassung der Arbeitsgänge wird benötigt, um den Dieselverbrauch je ha zu berechnen. 
        Tragen Sie die Anzahl der Durchgänge bzw. die Feld-Silo-Entfernung für die jeweiligen Arbeitsgänge ein.
         Die Herstellung von Saatgut verursacht Treibhausgasemissionen.`}
    >
      {renderTable()}
      <StyledGroup widths={'equal'}>
        <FormFields.Input
          control={control}
          rules={{
            required: true
          }}
          withoutAsterisk
          noErrorMessage
          suffix=' kg/ha'
          typeInput={'controled'}
          label={'Wie viel Saatgut wurde eingesetzt?'}
          placeholder={'in kg/ha'}
          name={'grassSilage.seedUsed'}
        />
      </StyledGroup>
    </SilageStepLayout>
  )
}

export default ThirdGrassStep